import { dateRangeSchema, levelSelectSchema } from '@retail/calculus/components';
import { CalculusTFunction } from '@retail/calculus/i18n';
import {
  numberWithOptionalDecimalRegex,
  percentageIncludingNegativeRegex,
} from '@retail/form/validation';
import * as yup from 'yup';

export const markupSchema = (t: CalculusTFunction, includeUnit?: boolean) =>
  yup.object({
    gtin: includeUnit
      ? yup
          .string()
          .default('')
          .when('level', {
            is: 'item',
            then: yup.string().default('').required(t('calculus.error.unit')),
          })
      : yup.string(),
    salesFactor: yup
      .string()
      .default('')
      .required(t('calculus.error.salesFactor'))
      .matches(numberWithOptionalDecimalRegex, t('calculus.error.mustBeNumberBetweenZeroAndTen')),
    salesCoverage: yup
      .string()
      .default('')
      .required(t('calculus.error.salesCoverage'))
      .matches(
        percentageIncludingNegativeRegex,
        t('calculus.error.mustBeNumberBetween', { min: -100, max: 100 })
      ),
  });

export const createOrUpdateMarkupSchema = (t: CalculusTFunction, includeUnit?: boolean) =>
  levelSelectSchema(t).concat(markupSchema(t, includeUnit).concat(dateRangeSchema(t)));

export type CreateOrUpdateMarkupSchema = yup.InferType<
  ReturnType<typeof createOrUpdateMarkupSchema>
>;
